/* eslint-disable */
import { BuildConfig } from '../models/build.config.model';

export const mockBuildConfig: BuildConfig = {
  header: {
    links: {
      home: 'https://www.domesticandgeneral.com',
      contact_us:
        'https://www.domesticandgeneral.com/content/contact-domestic-general',
      faq: 'https://www.domesticandgeneral.com/content/help-advice-section/faq/replacements',
      bookRepair: '',
    },
  },
  footer: {
    links: {
      terms: 'https://www.domesticandgeneral.com/web-terms-conditions',
      privacy: 'https://www.domesticandgeneral.com/privacy-cookies-policy',
      accessibility: 'https://www.domesticandgeneral.com/accessibility',
    },
  },
  dd_guarantee: 'https://www.domesticandgeneral.com/direct-debit-guarantee',
  domain: 'http://localhost:4200',
  pr: 'https://api.pr.test.test.athome.domgentest.cloud',
  common: 'https://api.common.test.test.athome.domgentest.cloud',
  recaptchaSiteKey: '6Lff8MAZAAAAABoVsbvcKunIcyQydc9rVjCV5NZ7',
  landingModalEnabled: true,
  isCovidNoticeEnabled: true,
  isBVOverrideEnabled: true,
};
